import React from "react";
import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import MarkEmailReadIcon from "@mui/icons-material/MarkEmailRead";

import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import { useCompleteMention } from "../../hooks/useCompleteMention";

const Dot = styled(Box)(({ theme }) => ({
  width: 8,
  height: 8,
  backgroundColor: theme.palette.error.main,
  borderRadius: "100%",
  cursor: "pointer",
}));

type Props = {
  mentionId: string;
  mentionType: string;
};

export function UnreadDot({ mentionId, mentionType }: Props) {
  const { isLoading, complete } = useCompleteMention(mentionId, mentionType);
  const [anchorEl, setAnchorEl] = React.useState<HTMLElement | null>(null);

  const handleMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = (event?: { stopPropagation?: () => void }) => {
    event?.stopPropagation?.();
    setAnchorEl(null);
  };

  const markAsRead = async (event: React.MouseEvent<HTMLLIElement>) => {
    if (isLoading) return;
    try {
      event.stopPropagation();
      await complete();
      handleMenuClose();
    } catch (e) {
      console.error(e);
    }
  };

  return (
    <>
      <IconButton size="small" onClick={handleMenuOpen} sx={{ p: 0.5 }}>
        <Dot />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleMenuClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        slotProps={{
          paper: {
            sx: {
              width: 180,
              maxWidth: "100%",
            },
          },
        }}
      >
        <MenuItem onClick={markAsRead} dense>
          <ListItemIcon>
            <MarkEmailReadIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText primary="Mark as read" />
        </MenuItem>
      </Menu>
    </>
  );
}
